import {
  CheckTicketCancelResponse,
  DetailedBalanceResponse,
  GetBalanceResponse,
  GetCancelationReasonsResponse,
  GetTopUpByIdResponse,
  GetTransactionsResponse,
} from '../types';
import { cancelationReasons, walletUrl, topUpUrl } from '../config';
import { createInfiniteQuery, createQuery } from '@/logic/libs';

import { ordersUrl } from '@/logic/services';

export const useGetTopUpById = createQuery<GetTopUpByIdResponse>({
  method: 'get',
  url: `${topUpUrl}/:topUpId`,
});

export const useGetBalance = createQuery<GetBalanceResponse>({
  method: 'get',
  url: `${walletUrl}/balance`,
});

export const useGetTransactions = createQuery<GetTransactionsResponse>({
  method: 'get',
  url: `${walletUrl}`,
});

export const useGetInfiniteTransactions = createInfiniteQuery<GetTransactionsResponse>(
  {
    method: 'get',
    url: `${walletUrl}`,
  },
  {
    staleTime: 0,
    keepPreviousData: false,
  }
);

export const useGetInfiniteExpiredTransactions =
  createInfiniteQuery<GetTransactionsResponse>({
    method: 'get',
    url: `${walletUrl}/expired`,
  });

export const useCheckTicketCancel = createQuery<CheckTicketCancelResponse>(
  {
    method: 'get',
    url: `${ordersUrl}/:orderId/check-cancel`,
  },
  {
    staleTime: 0,
    keepPreviousData: false,
  }
);

export const useGetCancellationReasons = createQuery<GetCancelationReasonsResponse>({
  method: 'get',
  url: cancelationReasons,
});

export const useGetDetailedBalanceQuery = createQuery<DetailedBalanceResponse>({
  method: 'get',
  url: `${walletUrl}/detailed-balance`,
});
